<template>
  <div class="columns box">
    <div class="notification page-integrations__notification--is-warning">
      <sc-icon icon="search" />
      Nenhum aplicativo encontrado para integração
    </div>
  </div>
</template>

<script>
import { ScIcon } from "@intelipost-js/secure-components";

export default {
  name: "page-integrations-home",

  components: {
    ScIcon,
  },
};
</script>

<style lang='scss'>
@import "~@intelipost-js/secure-ui/src/scss/variables";

.page-integrations {
  .filter-section {
    display: flex;
    justify-items: center;
    align-content: center;
    align-items: center;
    margin-bottom: 2rem;
  }

  .schema-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 2rem;

    input {
      background-color: none;
    }
  }

  .group-buttons {
    margin: 0 2rem;
    padding: none;
  }

  .input-filter {
    width: 50%;
  }

  .sc-card {
    .card-header-button {
      background: none;
      border: none;
    }

    .card-image {
      .image {
        padding-top: 60%;
      }
    }

    .card-menu-button {
      border: none;
      background-color: white;
      margin: 1rem 0 0 0;
    }

    .report-problem-form {
      display: flex;
      margin-bottom: 2rem;

      .report-problem-button {
        margin-top: 2rem;
      }
    }

    img {
      object-fit: scale-down;
      width: 80%;
      margin: auto;
      padding: 0.5rem;
    }
  }

  .schema-form {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-right: 2rem;
  }

  .modal_about__field {
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
  }

  &__cols {
    padding: 0.5rem;
  }

  &__col {
    width: 330px;
    padding: 0.5rem;
  }

  &__description {
    margin-bottom: 1rem;
  }

  &__notification {
    &--is-warning {
      font-size: 1.4rem;
      background-color: transparent;
      color: #767676;

      .icon {
        margin-right: 1.6rem;
        position: relative;
        top: 4px;
        font-size: 1.6rem;
      }
    }
  }

  &__icon {
    cursor: help;

    &--success {
      color: $primary;
    }

    &--danger {
      color: $danger;
    }
  }
}
</style>



// WEBPACK FOOTER //
// node_modules/@intelipost-modules/secure-integrations/components/app-list/empty-app-list/EmptyAppList.vue